import { Link } from "react-router";
import { Button } from "../components/ui/Button";
import Logo from "../assets/images/green-logo.png";
import { toPersianDate } from "../utils/dateFormatter";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";
import LazyImage from "./ui/LazyImage";

type Props = {
  person: any;
  loading: boolean;
  isFollowing: boolean;
  onToggleFollow: () => void;
  mode?: "desktop" | "mobile";
};
export default function ProjectFollowBox({
  isFollowing,
  loading,
  person,
  onToggleFollow,
  mode = "desktop",
}: Props) {
  const isDesktop = mode === "desktop";

  return (
    <div
      className={
        isDesktop
          ? "hidden xl:block bg-white shadow-sm p-2.5 space-y-2.5 xl:rounded-2xl overflow-hidden"
          : "flex justify-between items-center xl:hidden bg-green-05 shadow p-2.5 rounded-b-[20px] overflow-hidden"
      }
    >
      {/* title Desc*/}
      {isDesktop && (
        <span className="text-accent-05 text-base font-semibold">
          این مجموعه
        </span>
      )}

      {/* info */}
      <div
        className={`flex items-start gap-x-2 ${isDesktop ? "h-fit" : "h-fit"}`}
      >
        {person?.projects?.map((project: any) => (
          <div
            key={project.id}
            className="flex items-center gap-x-2.5"
          >
            <div
              className={`bg-green-01 shrink-0 border border-green-02 overflow-hidden ${
                isDesktop
                  ? "size-[70px] rounded-[19px]"
                  : "size-11 rounded-full"
              }`}
            >
              <LazyImage
                src={project?.logo || Logo}
                alt="لوگو"
                className="object-contain xl:object-cover bg-green-01"
              />
            </div>
            <div className="flex flex-col gap-y-1">
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Link
                      to={`/institutions/${project.id}`}
                      key={project.id}
                      className={`line-clamp-1 text-[15px] font-bold ${
                        isDesktop ? "text-green-05" : "text-white"
                      }`}
                    >
                      {project.name}
                    </Link>
                  </TooltipTrigger>
                  <TooltipContent className="font-estedad bg-green-02.5 text-green-05">
                    <p>{project.name}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
              {project.date_establishment && (
                <span
                  className={`text-[11px] font-medium ${isDesktop ? "text-green-04" : "text-white/60"}`}
                >
                  تاریخ تاسیس&nbsp;
                  {project.date_establishment
                    ? toPersianDate(project.date_establishment)
                    : ""}
                </span>
              )}
            </div>
          </div>
        ))}

        {/* <p
          className={`text-xs font-extrabold mt-1 ${
            isDesktop ? "text-green-06" : "text-white"
          }`}
        >
          {person?.name}
        </p> */}
      </div>

      {/* follow button */}
      <Button
        onClick={onToggleFollow}
        disabled={loading}
        className={`items-center justify-center text-[11px] xl:text-[15px] font-medium transition rounded-[10px]
                ${isDesktop ? "hidden xl:flex w-full" : "xl:hidden ml-3.5"}
                ${
                  isFollowing
                    ? isDesktop
                      ? "xl:bg-green-03 hover:bg-green-03/90"
                      : "bg-green-02 text-green-05 hover:bg-green-02"
                    : "bg-green-03 hover:bg-green-03 xl:hover:bg-green-05/90 xl:bg-green-05 text-white"
                }`}
      >
        {loading ? (
          <span className="size-4 border-2 mx-4 border-current border-t-transparent rounded-full animate-spin" />
        ) : isFollowing ? (
          "دنبال میکنید"
        ) : (
          "دنبال کردن"
        )}
      </Button>
    </div>
  );
}
